<template>
  <div class="form__flex form__flex-start">
    <div class="form__left">
      <VInput
        :id="setFieldId('name')"
        v-model="formData.name"
        name="name"
        :errors="v$.name.$errors"
        :server-errors="serverErrors.value?.name"
        :disabled="isBidder"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        :max-length="250"
        placeholder="Наименование товара/услуги"
        @blur="validateField"
        @input="validateField" />

      <VTextarea
        v-if="isBidder"
        id="participant_note"
        v-model="formData.participant_note"
        name="participant_note"
        label="Примечание поставщика"
        text-area-class="textarea-bg-transparent textarea-border-gray textarea-height-150 textarea-n-resize mb-40" />

      <VInput
        :id="setFieldId('price')"
        v-model="formData.price"
        name="price"
        type="number"
        :errors="v$.price.$errors"
        :server-errors="serverErrors.value?.price"
        :max="100"
        :class-form="[isBidder ? '' : ' mr-20']"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        :placeholder="isBidder ? `Ваша цена с НДС` : 'Начальная цена с НДС'"
        @input="
          (name) => {
            validateField(name)
            reCalc()
          }
        " />

      <div class="field_criterion">
        <VInput
          :id="setFieldId('quantity')"
          v-model="formData.quantity"
          name="quantity"
          type="number"
          :errors="v$.quantity.$errors"
          :server-errors="serverErrors.value?.quantity"
          :class-form="[isBidder ? '' : 'mr-20']"
          :class-input="['input input-long input-placeholder-black input-border-bottom']"
          placeholder="Количество"
          @blur="validateField"
          @input="
            (val) => {
              validateField(val)
              reCalc()
            }
          " />

        <VCheckbox
          v-if="!isBidder"
          id="is_quantity_coef"
          v-model="formData.is_quantity_coef"
          :class-form="['form-checkbox mb-20 small-checkbox']"
          name="is_quantity_coef"
          class-label="label"
          :value="formData.is_quantity_coef"
          @blur="validateField"
          @input="validateField">
          <template #default="slotProps">
            <label :for="slotProps.for" :class="slotProps.class"> Критерий </label>
          </template>
        </VCheckbox>
      </div>
    </div>

    <div class="form__right">
      <VSelect
        :id="setFieldId('measurement_id')"
        v-model="formData.measurement_id"
        name="measurement_id"
        :errors="v$.measurement_id.$errors"
        :server-errors="serverErrors.value?.measurement_id"
        :disabled="isBidder && !lot.analog_acceptable"
        :options="measurement"
        classes="select-border-bottom"
        class="input-long"
        placeholder="Ед. измерения"
        @blur="validateField"
        @input="validateField" />

      <VInput
        :id="setFieldId('characteristic')"
        v-model="formData.characteristic"
        name="characteristic"
        :errors="v$.characteristic.$errors"
        :max-length="301"
        :disabled="isBidder && !lot.analog_acceptable"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        placeholder="Характеристика товара/услуги"
        @blur="validateField"
        @input="validateField" />
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, onMounted, reactive } from 'vue'

import VSelect from '@/components/ui/form/VSelect'
import VInput from '@/components/ui/form/VInput'
import VCheckbox from '@/components/ui/form/Checkbox/VCheckbox'
import { manualMemoization } from '@/utils/memoization/manualMemoization'
import { MEASUREMENT } from '@/utils/manual/manualList'
import VTextarea from '@/components/ui/form/VTextarea'
import { useStore } from 'vuex'

const props = defineProps({
  formData: {
    type: Object,
    required: true,
  },
  v$: {
    type: Object,
    required: true,
  },
  serverErrors: {
    type: [Object, Array],
    required: true,
  },
  validateField: {
    type: Function,
    required: true,
  },
  isBidder: {
    type: Boolean,
    required: false,
  },
  reCalc: {
    type: Function,
    required: false,
  },
})

const store = useStore()
const measurement = reactive([])
const lot = computed(() => {
  return store.getters['lot/getLot']
})

onMounted(async () => {
  measurement.length = 0
  measurement.push(...(await manualMemoization(true, MEASUREMENT)))
})

function setFieldId(field) {
  return `lot-position__${field}--${props.formData.id}`
}
</script>

<style scoped>
.v-lot-pos {
  display: flex;
  width: 100%;
  max-width: 630px;
  flex-direction: column;
  align-items: center;
}
</style>
